// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Azerbaijan */
const AZ = /^(?:36554\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\d{7})$/;

export default AZ;
